export * from './app-breadcrumbs.component';



// WEBPACK FOOTER //
// /home/ubuntu/JointlyWebService/admin/CollabspaceAdminPortal/src/app/components/app-breadcrumbs/index.ts